module.exports = __webpack_public_path__ + "img/economy.0c8966f3.jpg";